import axios from "axios";

//export const BASEURL =  "http://localhost:3000/" 
export const BASEURL =   "https://meucrqce.crqx.org.br/"

const axiosApi = axios.create({
  baseURL: BASEURL
});


// Interceptor de resposta
axiosApi.interceptors.response.use(
  (response) => response, // Retorna a resposta se der tudo certo
  (error) => {
    // Verifica se o erro é de autenticação (401)
    if (error.response && error.response.status === 401) {
      // 1. Limpe os dados locais de autenticação
     // localStorage.removeItem('token'); 
      
      // 2. Redirecione para a tela de login
      window.location.href = '/login';
    }
    
    return Promise.reject(error);
  }
);


export default axiosApi;